module.exports = __webpack_public_path__ + "static/image2-885fbff9a34db0719c99357cd5222800.jpg";